<template>
  <div class="page-question">
    <div class="search-bar">
      <div class="input">
        <svg class="m-style-svg m-svg-def head-top-search-icon">
          <use xlink:href="#icon-search" />
        </svg>
        <form action="" @submit.prevent="() => {return false}">
          <input
            v-model="keywords"
            type="search"
            :placeholder="$t('search')"
            @keyup.enter="handleSearch"
          >
        </form>
      </div>
      <span class="cancel" @click="onCancel">{{ $t('cancel') }}</span>
    </div>
    <!-- App Bar. -->
    <nav class="nav">
      <RouterLink
        :to="navRouterLinkBuilder('share')"
        replace
        exact
        exact-active-class="active"
        @click.native="handleSearch"
      >
        {{ $t('feed.name') }}
      </RouterLink>
      <RouterLink
        :to="navRouterLinkBuilder('question')"
        replace
        exact
        exact-active-class="active"
        @click.native="handleSearch"
      >
        {{ $t('question.qa') }}
      </RouterLink>
      <RouterLink
        :to="navRouterLinkBuilder('group')"
        replace
        exact
        exact-active-class="active"
        @click.native="handleSearch"
      >
        {{ $t('group.name') }}
      </RouterLink>
      <RouterLink
        :to="navRouterLinkBuilder('post')"
        replace
        exact
        exact-active-class="active"
        @click.native="handleSearch"
      >
        {{ $t('group.post.name') }}
      </RouterLink>
      <RouterLink
        :to="navRouterLinkBuilder('expert')"
        replace
        exact
        exact-active-class="active"
        @click.native="handleSearch"
      >
        {{ $t('expert.name') }}
      </RouterLink>
    </nav>

    <!-- Module content. -->
    <main class="main-content">
      <JoLoadMore
        ref="loadmore"
        :auto-load="false"
        @onRefresh="onRefresh"
        @onLoadMore="onLoadMore"
      >
        <div v-for="item in list" :key="item.id">
          <UserItem
            v-if="currenttype === 'expert'"
            :key="`user-item-${item.id}`"
            :user="item"
          />
          <QuestionCard
            v-if="currenttype === 'question'"
            :key="item.id"
            :question="item"
          />
          <FeedCard
            v-if="currenttype==='share' || currenttype === 'post'"
            :key="item.id"
            :feed="item"
            :time-line="false"
            class="feed-card"
          />
          <GroupItem
            v-if="currenttype==='group'"
            :show-index="false"
            :group="item"
            :show-action="true"
          />
        </div>
      </JoLoadMore>
    </main>
  </div>
</template>

<script>
  import { getExperts, getShares, getQa, getGroups, getGroupPost } from '@/api/feeds'
  import UserItem from '@/components/UserItem'
  import GroupItem from '@/components/GroupItem.vue'
  import QuestionCard from '../question/components/QuestionCard.vue'
  import FeedCard from '@/components/FeedCard/FeedCard.vue'
  export default {
    name: 'SearchListSum',
    components: {
      UserItem,
      FeedCard,
      GroupItem,
      QuestionCard,
    },
    data () {
      return {
        keywords: '',
        list: [],
        param: { limit: 15 },
      }
    },
    computed: {
      currenttype () {
        return this.$route.query.type
      },
    },
    // watch: {
    //   currenttype (val) {
    //     if (val) this.handleSearch()
    //   },
    // },
    mounted () {
      this.handleSearch()
    },
    methods: {
      navRouterLinkBuilder (type) {
        return {
          path: '/search_list',
          query: { type },
        }
      },
      onRefresh () {
        const apis = { share: getShares, question: getQa, group: getGroups, post: getGroupPost, expert: getExperts }
        const api = apis[this.currenttype]
        const { keywords } = this
        const data = {}
        if (this.currenttype === 'expert') {
          data.select = 'all'
        }
        api && api({ ...this.param, ...data, keywords, keyword: keywords, subject: keywords, search: keywords }).then(({ data }) => {
          if (this.currenttype === 'share') {
            this.list = data.feeds || data
            this.$refs.loadmore.afterRefresh(this.list.length < this.param.limit)
            return
          }
          this.list = data
          this.$refs.loadmore.afterRefresh(data.length < this.param.limit)
        })
      },
      onLoadMore (callback) {
        const apis = { share: getShares, question: getQa, group: getGroups, post: getGroupPost, expert: getExperts }
        const api = apis[this.currenttype]
        const { keywords } = this
        const after = this.list[this.list.length - 1].id
        const data = {}
        if (this.currenttype === 'expert') {
          data.select = 'all'
          data.limit = 100
        }
        api({ ...this.param, ...data, keyword: keywords, subject: keywords, search: keywords, offset: this.list.length, after }).then(
          ({ data }) => {
            if (this.currenttype === 'share') {
              this.list = [...this.list, ...data.feeds]
              this.$refs.loadmore.afterLoadMore(data.feeds.length < this.param.limit)
              return
            }
            this.list = [...this.list, ...data]
            this.$refs.loadmore.afterLoadMore(data.length < this.param.limit)
          }
        )
      },
      onCancel () {
        this.$router.back()
      },
      handleSearch () {
        this.list = []
        this.$refs.loadmore.beforeRefresh()
      },
    },
  }
</script>

<style lang="less" scoped>
.page-question {
  padding-bottom: 0 !important;
  .search-bar {
    position: sticky;
    top: 0;
    z-index: 99;
    background-color: #fff;
    display: flex;
    padding: 20px 30px;
    height: 90px;
    .input {
      font-size:24px;
      background:rgba(247,247,247,1);
      opacity:1;
      border-radius:10px;
      flex-grow: 1;
      height: 50px;
      padding: 0 11px;
      display: flex;
      align-items: center;
      .head-top-search-icon {
        color: #A6A6A6;
        height: 24px;
        width: 24px;
        margin-right: 14px;
      }
      input {
        // width: 100%;
        flex-grow: 1;
        background:rgba(247,247,247,1);
      }
    }
    .cancel {
      font-size:30px;
      color: #00AEEF;
      margin-left: 30px;
    }
  }
  .nav {
    position: sticky;
    top: 90px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    max-width: 768px;
    height: 90px;
    background: #fff;
    color: #999;
    font-size: 30px;
    border-bottom: solid 1px #dedede; /* no */
    z-index: 10;

    > a {
      color: #999;
    }

    .active {
      color: #333;
    }
  }
  .main-content {
    margin-top: 0px;
  }
}

</style>
<style scoped>
.feed-card {
  margin-bottom: 20px;
}
</style>
